/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React from 'react';
import { Image } from 'react-bootstrap';

import * as S from './styles';

export interface IAmountDisplayProps {
  icon?: string;
  amount?: number;
  currency?: string;
  subTitle?: string;
}

export const AmountDisplay = (props: IAmountDisplayProps) => {
  const { icon, amount, currency, subTitle } = props;
  return (
    <>
      <S.Container>
        {/* <Image src={icon} width={100} height={100} /> */}
        <div>
          <S.Currency>
            {amount}
            <S.Subtitle>{subTitle}</S.Subtitle>
          </S.Currency>
        </div>
      </S.Container>
    </>
  );
};

AmountDisplay.defaultProps = {
  icon: 'https://i.ibb.co/6HFqvtb/hurricane.png',
  amount: '5000',
  currency: 'EC$',
  subTitle: '',
};
